<template>
  <div>
    <top-header :type="7" :placeholder="'请输入机构名称'" bgColor="#2F72F5" :textColor="'#fff'" :inputText="inputText" @comfirmText="comfirmText" />
    <div class="pad_t"></div>
    <div class="fixed">
      <div class="tab_con m_flex_box" ref="tabCon">
        <span :class="current === index ? 'active' : ''" v-for="(item, index) in tabList" :key="index" @click="changeType(index)">{{item.text}}</span>
      </div>
      <div class="tab_inner">
        <span :class="type === inner.type ? 'active' : ''" @click="setVal('type', inner.type)" v-for="(inner, ind_) in tabList[current].children" :key="ind_">{{inner.text}}</span>
      </div>
    </div>
    <div class="list" v-show="type==1||type==3||type==6||type==9||type==11||type==2||type==4||type==7||type==10||type==12" >
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="m_flex_box flex_vc inner" v-for="(item, index) in list" :key="index">
            <div class="left">
              <img v-if="type==1||type==3||type==6||type==9||type==11"   @click="toDetail(item.id)"  src="" alt="" v-lazy="imgPath + 'sCLF/' + item.compPic + '.jpg'">
              <img v-if="type==2||type==4||type==7||type==10||type==12"  @click="toShopDetail(item.id)" src="" alt="" v-lazy="imgPath + 'sCLF/' + item.headerPic + '.jpg'">
              <img v-if="type==5||type==8||type==13"  @click="toAgentDetail(item.id)"   src="" alt="" v-lazy="imgPath + 'sCLF/' + item.brokerImg + '.jpg'">
              <i :class="index < 3 ? 'before' : ''">top{{index + 1}}</i>
            </div>
            <div class="right">
              <h3 v-if="type==1||type==3||type==6||type==9||type==11"  @click="toDetail(item.id)" class="line_comp1">{{item.compName}}</h3>
              <h3 v-if="type==2||type==4||type==7||type==10||type==12"  @click="toShopDetail(item.id)" class="line_comp1">{{item.storeName}}</h3>
              <h3 v-if="type==5||type==8||type==13" @click="toAgentDetail(item.id)" class="line_comp1">{{item.brokerName}}</h3>

              <p v-if="type==1||type==3||type==6||type==9||type==11" class="address line_comp1">{{item.compAddress}}</p>
              <p v-if="type==2||type==4||type==7||type==10||type==12" class="address line_comp1">{{item.address}}</p>
              <p v-if="type==5||type==8||type==13" class="address line_comp1">{{item.address}}</p>
              <div class="m_flex_box flex_vc info">
                <p class="m_flex_box flex_vc">
                  <img src="@/assets/img/person_sm.png" alt="">
                  <span v-if="type==1||type==3||type==6||type==9||type==11">{{item.compPerson}}</span>
                  <span v-if="type==2||type==4||type==7||type==10||type==12">{{item.storePerson}}</span>
                  <span v-if="type==5||type==8||type==13">{{item.brokerName}}</span>
                </p>

                <a v-if="type==1||type==3||type==6||type==9||type==11" @click.stop="callTo(item.compPhone, 1, item.id)" class="m_flex_box flex_vc">
                  <img src="@/assets/img/tel.png" alt="">
                  <span>{{item.compPhone}}</span>
                </a>
                <a v-if="type==2||type==4||type==7||type==10||type==12"  @click.stop="callTo(item.storePhone, 1, item.id)"
                         class="m_flex_box flex_vc">
                  <img src="@/assets/img/tel.png" alt="">
                  <span>{{item.storePhone}}</span>
                </a>
                <a v-if="type==5||type==8||type==13" @click.stop="callTo(item.phone, 1, item.id)" class="m_flex_box flex_vc">
                  <img src="@/assets/img/tel.png" alt="">
                  <span>{{item.phone}}</span>
                </a>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div class="list" v-show="type==5||type==8||type==13" >
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div class="inner_ m_flex_box flex_vc flex_jz" v-for="(item, index) in list" :key="index" @click="toAgentDetail(item.id)">
            <div class="left">
              <img :src="imgPath + 'sClf/' + item.brokerImg + '.jpg'" alt="">
              <span :class="index < 3 ? 'before' : ''">top{{index + 1}}</span>
            </div>
            <div class="right">
              <h3 class="m_flex_box flex_jz flex_vc">
                <span>{{item.brokerName}}</span>
                <i>{{item.signCount}}套</i>
              </h3>
              <p v-show="type==5||type==13" class="address line_comp1">所属银行：{{item.compName}}</p>
              <p v-show="type==5||type==13" class="address line_comp1">代办点：{{item.storeName}}</p>
              <p v-show="type==8" class="address line_comp1">所属机构：{{item.compName}}</p>
              <p v-show="type==8" class="address line_comp1">所属门店：{{item.storeName}}</p>

            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
import slideImg from '@/components/slideImg'
export default {
  data() {
    return {
      current: 0,
      tabList: [{
        text: '网签排行',
        children: [{
          type:1,
          text: '房产经纪机构网签排行'
        },{
          type:2,
          text: '房产经纪门店网签排行'
        },{
          type:3,
          text: '银行授权分行网签排行'
        },{
          type:4,
          text: '银行授权网点网签排行'
        },{
          type:5,
          text: '银行操作员网签排行'
        }]
      },{
        text: '挂牌排行',
        children: [{
          type:6,
          text: '房产经纪机构挂牌排行'
        },{
          type:7,
          text: '房产经纪门店挂牌排行'
        },{
          type:8,
          text: '房产经纪人挂牌排行'
        }]
      },{
        text: '评价排行',
        children: [{
          type:9,
          text: '房产经纪机构评价排行'
        },{
          type:10,
          text: '房产经纪门店评价排行'
        },{
          type:11,
          text: '银行授权分行评价排行'
        },{
          type:12,
          text: '银行授权网点评价排行'
        },{
          type:13,
          text: '银行操作员评价排行'
        }]
      }],
      inputText: '',
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      listPage:1,
      timer: null,
      formData: {
        compType:0,
        statistics:2,
        storeName:'',
        area: this.main.getHostArea(),
        compName:''
      },
      type: 1,
      url_:'cms/brokerComp/permit/getBrokerCompListNew.do',
      nameshow:0  // 0 机构或者银行  1 门店或者代办点 2 经纪人或者操作员
    };
  },
  components: {
    topHeader,
    slideImg
  },
  mounted() {
  },
  methods: {
    callTo(phone, lx, infoId) {
      if(!phone) {
        this.$dialog.alert({
          title: '提示',
          message: '暂无可拨打电话'
        });
        return;
      }
      this.$new.post('telTj/addTeltj.do', qs.stringify({
        phone,
        lx,
        infoId
      })).then(res => {
        window.location.href = `tel:${phone}`
      })
    },
    onRefresh() {
      this.listPage = 1;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this.formData, 'compName', '');
      this.$set(this.formData, 'storeName', '');
      this.$set(this, 'nameshow', 0);
      this.$set(this.formData, 'compType', 0);
      this.$set(this, 'type', 1);
      this.$set(this, 'url_', 'cms/brokerComp/permit/getBrokerCompListNew.do');

      this.onLoad(1);
    },
    comfirmText(data) {
      if(this.type==1||this.type==3||this.type==6||this.type==9||this.type==11){
        this.$set(this.formData, 'compName', data);
        this.$set(this.formData, 'storeName', '');
      }else{
        this.$set(this.formData, 'storeName', data);
        this.$set(this.formData, 'compName', '');
      }
      this.inputText = data;
      this.loading = false;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'listPage', 1);
      this.onLoad();
    },

    changeType(type) {
      this.current = type;
      this.inputText = '';
      this.$set(this.formData, 'compName', '');
      this.$set(this.formData, 'storeName', '');
      if(this.current==0){
        this.$set(this, 'type', 1);
        this.$set(this.formData, 'compType', 0);
      }
      if(this.current==1){
        this.$set(this, 'type', 6);
        this.$set(this.formData, 'compType', 0);
      }
      if(this.current==2){
        this.$set(this, 'type', 9);
        this.$set(this.formData, 'compType', 0);
      }
      this.listPage = 1;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this, 'url_', 'cms/brokerComp/permit/getBrokerCompListNew.do');
      this.$set(this, 'nameshow', 0);
      this.onLoad();
    },

    setVal(type, v) {
      this.inputText = '';
      this.$set(this, type, v);
      this.listPage = 1;
      this.finished = false;
      this.$set(this, 'list', []);
      this.$set(this.formData, 'compName', '');
      this.$set(this.formData, 'storeName', '');
      //判断调用是哪个url
      if(this.current==0){//网签排行
        if(this.type==1){//房产经纪机构网签排行
          this.url_ = 'cms/brokerComp/permit/getBrokerCompListNew.do';
          this.$set(this.formData, 'compType', 0);
        }else if(this.type==2){//房产经纪门店网签排行
          this.url_ = 'cms/brokerStore/permit/getBrokerStoreListNew.do';
          this.$set(this.formData, 'compType', 0);
        }else if(this.type==3){//银行授权分行网签排行
          this.url_ = 'cms/brokerComp/permit/getBrokerCompListNew.do';
          this.$set(this.formData, 'compType', 1);
        }else if(this.type==4){//银行授权网点网签排行
          this.url_ = 'cms/brokerStore/permit/getBrokerStoreListNew.do';
          this.$set(this.formData, 'compType', 1);
        }else{//银行操作员网签排行
          this.url_ = 'cms/broker/permit/getBrokerListNew.do';
          this.$set(this.formData, 'compType', 1);
        }
      }else if(this.current==1){//挂牌排行
        if(this.type==6){//房产经纪机构挂牌排行
          this.url_ = 'cms/brokerComp/permit/getBrokerCompListNew.do';
          this.$set(this.formData, 'compType', 0);
        }else if(this.type==7){//房产经纪门店挂牌排行
          this.url_ = 'cms/brokerStore/permit/getBrokerStoreListNew.do';
          this.$set(this.formData, 'compType', 0);
        }else{//房产经纪人挂牌排行
          this.url_ = 'cms/broker/permit/getBrokerListNew.do';
          this.$set(this.formData, 'compType', 0);
        }
      }else{//评价排行
        if(this.type==9){//房产经纪机构评价排行
          this.url_ = 'cms/brokerComp/permit/getBrokerCompListNew.do';
          this.$set(this.formData, 'compType', 0);
        }else if(this.type==10){//房产经纪门店评价排行
          this.url_ = 'cms/brokerStore/permit/getBrokerStoreListNew.do';
          this.$set(this.formData, 'compType', 0);
        }else if(this.type==11){//银行授权分行评价排行
          this.url_ = 'cms/brokerComp/permit/getBrokerCompListNew.do';
          this.$set(this.formData, 'compType', 1);
        }else if(this.type==12){//银行授权网点评价排行
          this.url_ = 'cms/brokerStore/permit/getBrokerStoreListNew.do';
          this.$set(this.formData, 'compType', 1);
        }else{//银行操作员评价排行
          this.url_ = 'cms/broker/permit/getBrokerListNew.do';
          this.$set(this.formData, 'compType', 1);
        }
      }
      this.onLoad();
    },


    toDetail(id) {
      var compType = this.formData.compType;
      this.$router.push({
        path: '/mechanismDetail',
        query: {id, compType}
      })
    },
    toShopDetail(id) {
      var compType = this.formData.compType;
      this.$router.push({
        path: '/shopDetail',
        query: {id, compType}
      })
    },



    toAgentDetail(id) {
      var compType = this.formData.compType;
      this.$router.push({
        path: '/agentDetail',
        query: {id, compType}
      })
    },



    onLoad(type) {
      if(!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$http({
          url: this.url_,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            compType: this.formData.compType,
            pageSize: 10,
            offset: (this.listPage - 1) * 10,
            sort: this.current,
            statistics: this.formData.statistics,
            storeName: this.formData.storeName,
            compName:this.formData.compName,
            area: this.formData.area
          }
        }).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows)
            this.loading = false;
            this.listPage += 1;
          } else {
            this.finished = true;
          }
        })
      }
    },

  },
};
</script>
<style lang="less" scoped>
  .inner_{
    padding: 0.34rem 0;
    border-bottom: 1px solid #f5f5f5;
    .left{
      margin-right: 0.26rem;
      position: relative;
      img{
        width: 1.3rem;
        height: 1.3rem;
        display: block;
        border-radius: 50%;
      }
      span{
        display: block;
        position: absolute;
        background-color: #404040;
        color: #fff;
        width: 0.8rem;
        line-height: 0.38rem;
        border-radius: 0 0.08rem 0 0.08rem;
        font-size: 0.22rem;
        text-align: center;
        top: 1rem;
        left: 50%;
        margin-left: -0.4rem;
        font-weight: 800;
        &.before{
          background-color: #FF342A;
        }
      }
    }
    .right{
      width: 5.45rem;
      h3{
        font-size: 0.3rem;
        font-weight: 600;
        i{
          font-size: 0.26rem;
          font-weight: 600;
        }
      }
      .address{
        font-size: 0.24rem;
        color: #909090;
        margin: 0.1rem 0;
      }
    }
  }
&.fixed{
  position: fixed;
  top: 1.1rem;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 2;
}
.pad_t{
  padding-top: 2.12rem;
}
.tab_con{
  padding: 0.1rem 0.23rem 0;
  font-size: 0.32rem;
  border-bottom: 1px solid #f5f5f5;
  span{
    padding: 0.18rem 0;
    position: relative;
    margin-right: 0.7rem;
    &.active{
      font-weight: 800;
      &:after{
        content: '';
        display: block;
        background-color: #2F72F5;
        width: 0.5rem;
        height: 0.04rem;
        position: absolute;
        left: 50%;
        margin-left: -0.25rem;
        bottom: 0;
      }
    }
  }
}
.tab_inner{
  padding: 0.3rem 0.23rem;
  overflow: auto;
  white-space: nowrap;
  border-bottom: 1px solid #f5f5f5;
  span{
    background-color: #F6F6F6;
    padding: 0 0.24rem;
    line-height: 0.58rem;
    font-size: 0.26rem;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 0.14rem;
    &:last-child{
      margin-right: 0;
    }
    &.active{
      color: #2F72F5;
      border: 1px solid #2F72F5;
      background-color: #EAF1FF;
    }
  }
}
.list{
  width: 7.04rem;
  margin: 0 auto;
  .inner{
    border-bottom: 1px solid #F4F4F4;
    padding: 0.34rem;
    .left{
      width: 2.14rem;
      height: 1.6rem;
      box-sizing: border-box;
      position: relative;
      img{
        width: 100%;
        height: 100%;
      }
      i{
        background-color: #404040;
        color: #fff;
        width: 0.8rem;
        line-height: 0.38rem;
        border-radius: 0 0.08rem 0 0.08rem;
        font-size: 0.22rem;
        text-align: center;
        position: absolute;
        top: 0;
        left: 0;
        &.before{
          background-color: #FF342A;
        };
      }
    }
    .right{
      width: 4rem;
      margin-left: 0.2rem;
      h3{
        font-size: 0.3rem;
        font-weight: 600;
        margin-bottom: 0.24rem;
      }
      .address{
        font-size: 0.24rem;
        color: #505050;
        margin-bottom: 0.24rem;
      }
      .info{
        color: #505050;
        font-size: 0.24rem;
        p{
          margin-right: 0.4rem;
        }
        img{
          width: 0.32rem;
          margin-right: 0.1rem;
        }
      }
    }
  }
}
</style>